export var CommonSchemaIds;
(function (CommonSchemaIds) {
    CommonSchemaIds["UUID"] = "uuid";
    CommonSchemaIds["NAME"] = "name";
    CommonSchemaIds["TITLE"] = "title";
    CommonSchemaIds["LOCALE"] = "locale";
    CommonSchemaIds["UUID_LIST"] = "uuids";
    CommonSchemaIds["SYSTEM_ADMIN_ROLES"] = "adminuuids";
    CommonSchemaIds["ROLE"] = "rolefk";
    CommonSchemaIds["ROLES"] = "roles";
    CommonSchemaIds["RESELLER"] = "resellerfk";
    CommonSchemaIds["DOMAIN"] = "domainfk";
    CommonSchemaIds["DOMAIN_ADMINISTRATORS"] = "administrators";
    CommonSchemaIds["ACTIVE"] = "active";
    CommonSchemaIds["DELETED"] = "deleted";
    CommonSchemaIds["EMAIL"] = "email";
    CommonSchemaIds["SECRET"] = "secret";
    CommonSchemaIds["JWT"] = "jwt";
    CommonSchemaIds["BEARER_TOKEN"] = "authorization";
})(CommonSchemaIds || (CommonSchemaIds = {}));
